import { ErrorType as playerErrorTypes } from 'playback-web-player';

/**
 * See Player error types:
 * https://github.com/getndazn/playback-web-player/blob/develop/src/Shared/Constants/ErrorType.ts
**/

const ErrorType = {
    ...playerErrorTypes,

    // Api Errors
    API_SERVICE_PLAYBACK: 'API_SERVICE_PLAYBACK',
    API_SERVICE_PRECISION: 'API_SERVICE_PRECISION',
    API_SERVICE_CONCURRENCY: 'API_SERVICE_CONCURRENCY',
    API_SERVICE_RESUME_POINTS: 'API_SERVICE_RESUME_POINTS',

    // Playback Api Payload Errors
    API_SERVICE_PLAYBACK_MISSING_DATA: 'API_SERVICE_PLAYBACK_MISSING_DATA',
    API_SERVICE_PLAYBACK_MEDIA_UNAVAILABLE: 'API_SERVICE_PLAYBACK_MEDIA_UNAVAILABLE',
    API_SERVICE_PLAYBACK_ASSET_UNAVAILABLE: 'API_SERVICE_PLAYBACK_ASSET_UNAVAILABLE',
    API_SERVICE_PLAYBACK_PLAYBACKDETAILS_UNAVAILABLE: 'API_SERVICE_PLAYBACK_PLAYBACKDETAILS_UNAVAILABLE',

    // Playback Api Service Errors
    API_SERVICE_PLAYBACK_RESTRICTED_LOCATION: 'API_SERVICE_PLAYBACK_RESTRICTED_LOCATION',
    API_SERVICE_PLAYBACK_CONCURRENT_USER_LIMIT: 'API_SERVICE_PLAYBACK_CONCURRENT_USER_LIMIT',

    // Rotation Errors
    PLAYBACK_SOURCE_STARTUP: 'PLAYBACK_SOURCE_STARTUP',
    PLAYBACK_SOURCE_MIDSTREAM: 'PLAYBACK_SOURCE_MIDSTREAM',

    EXCESSIVE_BUFFERING: 'EXCESSIVE_BUFFERING',

    UNKNOWN_ERROR: 'UNKNOWN_ERROR',
};

export default ErrorType;
